import {
    CLAPI
} from '../clchart/cl.api.js'

export function reverseIndex(index, count, value) {
    if (index < 0 || index > count - 1) {
        return value ?? index
    }
    const newindex = count - 1 - index
    return newindex
}

export function strsToArray(strs) {
    return strs.split(/\s*,\s*/);
}
export function getfloatLR(rect, x) {
    if (x < rect.left + rect.width / 2) {
        return 'left'
    }
    return 'right'
}

export function getArrayIndex(inindex, maxnums, rtindex) {
    let index = 0
    if (rtindex !== undefined) {
        index = rtindex
    } 
    if (inindex >= 0 && inindex < maxnums) {
        index = inindex
    }
    return index
}

export function fieldsToFieldsIndex(fields) {
    const arrayFds = fields.split(/\s*,\s*/);
    let indexFds = {}
    for (let index = 0; index < arrayFds.length; index++) {
        indexFds[arrayFds[index]] = index
    }
    return indexFds
}

export function fieldsMergeFieldsIndex(infields, fields, exfields) {
    const arrFds = fields.split(/\s*,\s*/);
    const arrExs = []
    if (exfields !== undefined) {
        arrExs = exfields.split(/\s*,\s*/);
    }
    const arrIns = infields.split(/\s*,\s*/);
    let indexFds = {}
    let indexSno = 0
    for (let index = 0; index < arrIns.length; index++) {
        indexFds[arrIns[index]] = indexSno++
    }
    for (let index = 0; index < arrFds.length; index++) {
        if (!arrExs.includes(arrFds[index])) {
            indexFds[arrFds[index]] = indexSno++
        }
    }
    return indexFds
}
// 用 newfields 替换 srcfields 中字段
export function fieldsUpdateFieldsIndex(newfields, srcfields, incfields) {
    const newFds = newfields.split(/\s*,\s*/);
    const srcFds = srcfields.split(/\s*,\s*/);
    const incFds = incfields.split(/\s*,\s*/);
    let indexFds = {}
    let indexSno = 0
    for (let index = 0; index < srcFds.length; index++) {
        if (index < newFds.length) {
            indexFds[newFds[index]] = indexSno++
        } else {
            indexFds[srcFds[index]] = indexSno++
        }
    }
    for (let index = 0; index < incFds.length; index++) {
        indexFds[incFds[index]] = indexSno++
    }
    // console.log(indexFds);
    return indexFds
}

// 画日线
export function mAinfoToKeyInfo(indata) {
    // keyInfo['SH600600'] = {} 这种方式生成一个 keyInfo 字典传入 chart 中
    // 例子 SH600600 = { static : {}, frights : [[]] }

    let keyInfo = {}
    for (let index = 0; index < indata.datas.length; index++) {
        const key = CLAPI.getData(indata, 'code', index)
        keyInfo[key] = {
            index : index,
            static: {
                name: CLAPI.getData(indata, 'name', index),
                coindot: 2,
                curdate: CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
                curmsec: CLAPI.getData(indata, 'msec', index),
                style: CLAPI.getData(indata, 'style', index) ? CLAPI.STOCK_TYPE_STK : CLAPI.STOCK_TYPE_IDX,
                agoprc: CLAPI.getData(indata, 'agoprc', index),
                stopmax: CLAPI.getData(indata, 'stopup', index),
                stopmin: CLAPI.getData(indata, 'stopdn', index),
                wstake: CLAPI.getData(indata, 'wstake', index),
                fstake: CLAPI.getData(indata, 'fstake', index),
                income: CLAPI.getData(indata, 'income', index) / CLAPI.getData(indata, 'wstake', index),
            },
        }
    }
    return keyInfo
}

// 只有一个股票
export function AinfoToKeyInfo(indata) {
    // keyInfo['SH600600'] = {} 这种方式生成一个 keyInfo 字典传入 chart 中
    // 例子 SH600600 = { static : {}, frights : [[]] }

    let keyInfo = {}
    const index = -1
    const key = CLAPI.getData(indata, 'code', index)
    keyInfo[key] = {
        static: {
            name: CLAPI.getData(indata, 'name', index),
            coindot: 2,
            curdate: CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
            curmsec: CLAPI.getData(indata, 'msec', index),
            style: CLAPI.getData(indata, 'style', index) ? CLAPI.STOCK_TYPE_STK : CLAPI.STOCK_TYPE_IDX,
            agoprc: CLAPI.getData(indata, 'agoprc', index),
            stopmax: CLAPI.getData(indata, 'stopup', index),
            stopmin: CLAPI.getData(indata, 'stopdn', index),
            wstake: CLAPI.getData(indata, 'wstake', index),
            fstake: CLAPI.getData(indata, 'fstake', index),
            income: CLAPI.getData(indata, 'income', index) / CLAPI.getData(indata, 'wstake', index),
        },
    }
    if (indata.datas.length > 1) {
        keyInfo[key].frights = []
        let fright = 1.0
        for (let index = indata.datas.length - 1; index >= 0; index--) {
            keyInfo[key].frights.unshift([CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)), fright])
            // if (index > indata.datas.length - 20)
            // console.log(keyInfo[key].frights[0])
            fright *= CLAPI.getData(indata, 'fright', index)
        }
    }
    return keyInfo
}

// 只有一个股票
export function AinfoToKeyWord(indata) {
    // 例子 SH600600 = { static : {}, frights : [[]] }
    const index = -1
    const keyWord = {
        static: {
            code: CLAPI.getData(indata, 'code', index),
            name: CLAPI.getData(indata, 'name', index),
            coindot: 2,
            curdate: CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
            curmsec: CLAPI.getData(indata, 'msec', index),
            style: CLAPI.getData(indata, 'style', index) ? CLAPI.STOCK_TYPE_STK : CLAPI.STOCK_TYPE_IDX,
            agoprc: CLAPI.getData(indata, 'agoprc', index),
            stopmax: CLAPI.getData(indata, 'stopup', index),
            stopmin: CLAPI.getData(indata, 'stopdn', index),
            wstake: CLAPI.getData(indata, 'wstake', index),
            fstake: CLAPI.getData(indata, 'fstake', index),
            income: CLAPI.getData(indata, 'income', index) / CLAPI.getData(indata, 'wstake', index),
        },
        frights : []
    }
    if (indata.datas.length > 1) {
        let fright = 1.0
        for (let index = indata.datas.length - 1; index >= 0; index--) {
            keyWord.frights.unshift([CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)), fright])
            fright *= CLAPI.getData(indata, 'fright', index)
        }
    }
    return keyWord
}

export function stopInfoSetNewp(ninfos, newpInfo, ainfos) {
    if (newpInfo === undefined) {
        newpInfo = {}
    }
    for (let index = 0; index < ninfos.datas.length; index++) {
        const code = CLAPI.getData(ninfos, 'code', index)
        let midp = CLAPI.getData(ninfos, 'newprc', index)
        if (midp < 0.01) {
            for (let ai = 0; ai < ainfos.datas.length; ai++) {
                if (code === CLAPI.getData(ainfos, 'code', ai)) {
                    midp = CLAPI.getData(ainfos, 'agoprc', ai)
                    break;
                }               
            }
        }
        const curMsec = CLAPI.getData(ninfos, 'msec', index)
        if (newpInfo[code] === undefined) {
            newpInfo[code] = { msec : curMsec, newp : midp}
        }
        if (curMsec >= newpInfo[code].msec) {
            newpInfo[code].msec = curMsec
            newpInfo[code].newp = midp
        }
    }
    return newpInfo
}

export function AminuToMinute(indata) {
    let minus = []
    for (let km = 0; km < 240; km++) {
        minus.push([0,0,0,0,0, 0,0,0,0,0, -1, '0'])
    }
    let agominu = -1
    let curv = 0
    let curm = 0
    for (let index = 0; index < indata.datas.length; index++) {
        let curminu = CLAPI.Utils.getTradeMsecToIndex(indata.datas[index][0], CLAPI.STOCK_TRADETIME);
        if (curminu > 239) {
            curminu = 239
        }
        if (agominu >= 0) {
            curv = CLAPI.getData(indata, 'sumv', index) - minus[agominu][5]
            curm = CLAPI.getData(indata, 'summ', index) - minus[agominu][6]
        } else {
            curv = CLAPI.getData(indata, 'sumv', index)
            curm = CLAPI.getData(indata, 'summ', index)
        }

        const nowv = minus[curminu]
        nowv[0] = CLAPI.getData(indata, 'msec', index)
        nowv[1] = CLAPI.getData(indata, 'open', index)
        nowv[2] = CLAPI.getData(indata, 'maxp', index)
        nowv[3] = CLAPI.getData(indata, 'minp', index)
        nowv[4] = CLAPI.getData(indata, 'newp', index)

        nowv[5] = CLAPI.getData(indata, 'sumv', index)
        nowv[6] = CLAPI.getData(indata, 'summ', index)
        nowv[7] = curv
        nowv[8] = curm
        nowv[9] = CLAPI.getData(indata, 'summ', index)/CLAPI.getData(indata, 'sumv', index)

        nowv[10] = curminu   
        agominu = curminu
    }
    // 处理没有数据的分钟线
    for (let index = 0; index < minus.length; index++) {
        if (minus[index][10] === -1) {
            if (index % 240 === 0) {
                // 向后找
                for (let fi = index + 1; fi < minus.length; fi++) {
                    if (minus[fi][10] !== -1) {
                        cloneMinute(minus[fi], minus[index], index) 
                        break
                    }
                }
            }
            else {
                // 向前找
                for (let fi = index - 1; fi >= 0; fi--) {
                    if (minus[fi][10] !== -1) {
                        cloneMinute(minus[fi], minus[index], index) 
                        break
                    }
                }
            }
        }       
    }
    return {
        fields: {
            msec: 0, // 按交易时间的分钟索引
            open: 1,
            maxp: 2,
            minp: 3,
            newp: 4,
            sumv: 5,
            summ: 6,
            curv: 7,
            curm: 8,
            avgp: 9,
            index: 10,
        },
        datas: minus
    }
}
export function TrendToAxisXinfo(indata, nfield) {
    let oInfos = []
    // 这里要生成X轴的数据 
    for (let index = 0; index < indata.datas.length; index++) {
        if (CLAPI.getData(indata, 'stoped', index) !== 0) {
            continue
        }
        oInfos.push(CLAPI.Utils.getMsecDate(CLAPI.getData(indata, nfield, index)))
    }
    return oInfos
}

export function AdateToAxisXinfo(indata, nfield) {
    let oInfos = []
    // 这里要生成X轴的数据 
    for (let index = 0; index < indata.datas.length; index++) {
        oInfos.push(CLAPI.Utils.getMsecDate(CLAPI.getData(indata, nfield, index)))
    }
    return oInfos
}

export function AminuToAxisXinfo(indata, nfield) {
    let timeInfo = []
    let dateInfo = []
    let curdate = 0
    // 这里要生成X轴的数据 
    curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, nfield, 0))
    dateInfo.push(curdate)
    for (let km = 0; km < 240; km++) {
        timeInfo.push(fromIndexToMinu(km, CLAPI.STOCK_TRADETIME))
    }
    return {
        timeInfo,
        dateInfo
    }
}
// 提取某一列
export function extractField(indata, nfield) {
    return indata.datas.map(row => row[indata.fields[nfield]]);
}

export function fromIndexToMinu(tindex, tradetime) {
    let index = tindex
    let offset = 0
    let nowmin = 0
    for (let i = 0; i < tradetime.length; i++) {
        nowmin = CLAPI.Utils.getMinuteGap(tradetime[i][0], tradetime[i][1])
        if (index < nowmin) {
            offset = CLAPI.Utils.getMinuteOffset(tradetime[i][0], index + 1)
            return CLAPI.Utils.fromMinuteToStr(offset)
        }
        index -= nowmin
    }
    return 0
}

// 格式化 msec_t 为指定字符串
export function fromMsecToMinu(msec, tradetime) {
    const mtime = new Date(msec)
    let curminu = mtime.getHours() * 100 + mtime.getMinutes()
    const start = tradetime[0][0]
    const stop = tradetime[tradetime.length - 1][1]
    if (curminu <= start) {
        return CLAPI.Utils.fromMinuteToStr(start)
    } else if (curminu >= stop) {
        return CLAPI.Utils.fromMinuteToStr(stop)
    }
    return CLAPI.Utils.fromMinuteToStr(curminu)
}

export function swapDatefromMsec(indata, field) {
    const datas = []
    for (let index = indata.datas.length - 1; index >= 0; index--) {
        const msec = CLAPI.getData(indata, field, index)
        datas.push([CLAPI.Utils.getMsecDate(msec)])
    }
    return { 
        fields : {
            date : 0
        }, 
        datas: datas
    }
}
export function calcSubVal(lv, rv) {
    let ov = 0.0
    if (lv > 0.000001 && rv > 0.00001) {
        ov = Math.abs(lv - rv)
    } else if (lv < -0.000001 && rv < -0.00001) {
        ov = -1 * Math.abs(lv - rv)
    } else {
        ov = Math.abs(lv) + Math.abs(rv)
    }
    return ov
}

export function calculateSharpeRatio(returns, isAnnualized = true, riskFreeRate = 0, tradingDays = 252) {
    // 验证输入数据
    if (!Array.isArray(returns) || returns.length < 2) {
        throw new Error("至少需要2个交易日的收益数据");
    }
    
    // 计算每日收益率的平均值
    const meanReturn = returns.reduce((sum, ret) => sum + ret, 0) / returns.length;
    
    // 计算收益率的标准差
    const squaredDeviations = returns.map(ret => Math.pow(ret - meanReturn, 2));
    const variance = squaredDeviations.reduce((sum, val) => sum + val, 0) / (returns.length - 1); // 使用样本标准差
    const stdDev = Math.sqrt(variance);
    
    // 计算超额收益率（减去无风险利率的日均值）
    const dailyRiskFree = riskFreeRate / tradingDays; // 将年化无风险利率转换为日利率
    const excessReturn = meanReturn - dailyRiskFree;
    
    // 计算夏普比率
    let sharpeRatio = excessReturn / stdDev;
    
    // 如果需要年化处理
    if (isAnnualized) {
        sharpeRatio *= Math.sqrt(tradingDays);
    }
    
    return parseFloat(sharpeRatio.toFixed(4)); // 保留4位小数
}

export function isIndex(curKey) {
    if (curKey === 'SH000001' || curKey === 'SZ399001' || curKey === 'SH000300' || curKey === 'SZ399006' || curKey === 'CN000001') {
        return 1;
    }
    return 0;
}

// 日线除权的函数集合

// // /**
// //  * get exright para
// //  * @param {String} rightdata
// //  * @return {Object}
// //  */
// function _getExrightPara (rightdata) {
//   let exrightGs = 1000 // 送股数
//   let exrightPg = 0 // 配股数
//   let exrightPx = 0 // 利息
//   if (rightdata[FIELD_RIGHT.accrual]) exrightPx = rightdata[FIELD_RIGHT.accrual] / 10
//   if (rightdata[FIELD_RIGHT.sendstock] > 0 || rightdata[FIELD_RIGHT.allotstock] > 0) {
//     exrightGs = 1000 + rightdata[FIELD_RIGHT.sendstock] / 10 + rightdata[FIELD_RIGHT.allotstock] / 10
//     exrightPg = -rightdata[FIELD_RIGHT.allotprice] * rightdata[FIELD_RIGHT.allotstock] / 10000
//   }
//   return {
//     gs: exrightGs,
//     pg: exrightPg,
//     px: exrightPx
//   }
// }

// /**
//  * @param {Number} price
//  * @param {Object} rightpara
//  * @param {String} mode
//  * @return {Number}
//  */
// function _getExrightPrice (price, rightpara, mode) {
//   if (mode === 'forword') {
//     price = (price * 1000 - rightpara.pg - rightpara.px) * 1000 / rightpara.gs
//   } else {
//     price = price * 1000 * rightpara.gs / 1000 + rightpara.pg + rightpara.px
//   }
//   return price / 1000
// }
// // 得到某个价格的除权价
// /**
//  * Get an exemption price for a price
//  * @export
//  * @param {Number} start
//  * @param {Number} stop
//  * @param {Number} price
//  * @param {Array} rights
//  * @return {Number}
//  */
// export function getExrightPriceRange (start, stop, price, rights) {
//   if (rights === undefined || rights.length < 1) return price
//   let rightpara
//   for (let j = 0; j < rights.length; j++) {
//     if (rights[j][0] > start && rights[j][0] <= stop) {
//       rightpara = _getExrightPara(rights[j])
//       price = _getExrightPrice(price, rightpara, 'forword')
//       break
//     }
//   }
//   return price
// }
// const FIELD_DATE = {
//     time: 0,
//     open: 1,
//     maxp: 2,
//     minp: 3,
//     newp: 4,
//     sumv: 5,
//     summ: 6
// }
// /**
//  * transfer exright
//  * @private
//  * @param {Array} days
//  * @param {Array} rightdata
//  * @param {String} mode
//  * @param {Number} start
//  * @param {Number} end
//  */
// function _transExright (days, rightdata, mode, start, end) {
//   const rightpara = _getExrightPara(rightdata)
//   if (mode === 'forword') {
//     for (let i = start; i < end; i++) {
//       days[i][FIELD_DATE.open] = _getExrightPrice(days[i][FIELD_DATE.open], rightpara, mode) // open
//       days[i][FIELD_DATE.high] = _getExrightPrice(days[i][FIELD_DATE.high], rightpara, mode) // high
//       days[i][FIELD_DATE.low] = _getExrightPrice(days[i][FIELD_DATE.low], rightpara, mode) // low
//       days[i][FIELD_DATE.close] = _getExrightPrice(days[i][FIELD_DATE.close], rightpara, mode) // new
//       days[i][FIELD_DATE.vol] = days[i][FIELD_DATE.vol] * rightpara.gs / 1000
//     }
//   }
// }

// // 判断是否有除权
// /**
//  * check is right
//  * @param {Date} dateBegin
//  * @param {Date} dateEnd
//  * @param {Date} rightdate
//  * @return {Boolean}
//  */
// function _isRight (dateBegin, dateEnd, rightdate) {
//   if (rightdate > dateBegin && rightdate <= dateEnd) {
//     return true
//   } else return false
// }
// // 对日线进行除权，周年线不能除权，,days传入时就是一个可修改的数组
// /**
//  *
//  *
//  * @export
//  * @param {Array} days
//  * @param {Array} rights
//  * @param {String} mode
//  * @param {Number} start
//  * @param {Number} end
//  * @return {Array}
//  */
// export function transExrightDay (days, rights, mode, start, end) {
//   if (rights.length < 1 || days.length < 1) return days
//   if (mode === undefined) mode = 'forword' // 以最近的价格为基准,修正以前的价格;
//   if (start === undefined || start < 0 || start > days.length - 1) start = 0
//   if (end === undefined || end < 0) end = days.length - 1

//   if (mode === 'forword') {
//     for (let i = start; i <= end; i++) {
//       for (let j = 0; j < rights.length; j++) {
//         if (i < 1) continue
//         if (_isRight(days[i - 1][FIELD_DATE.time], days[i][FIELD_DATE.time], rights[j][FIELD_RIGHT.time])) {
//           _transExright(days, rights[j], mode, start, i)
//           break
//         }
//       }
//     }
//   } else if (mode === 'backword') {}
//   return days
// }

// // 对分钟线除权,days传入时就是一个可修改的数组
// /**
//  * transfer exrigth min data
//  * @export
//  * @param {Array} days
//  * @param {Array} rights
//  * @param {String} mode
//  * @param {Number} start
//  * @param {Number} end
//  * @return {Array}
//  */
// export function transExrightMin (days, rights, mode, start, end) {
//   if (rights.length < 1 || days.length < 1) return days
//   if (mode === undefined) mode = 'forword' // 以最近的价格为基准,修正以前的价格;
//   if (start === undefined || start < 0 || start > days.length - 1) start = 0
//   if (end === undefined || end < 0) end = days.length - 1

//   if (mode === 'forword') {
//     for (let i = start; i <= end; i++) {
//       for (let j = 0; j < rights.length; j++) {
//         if (i < 1) continue
//         if (_isRight(
//           getDate(days[i - 1][FIELD_DATE.time]),
//           getDate(days[i][FIELD_DATE.time]),
//           rights[j][FIELD_RIGHT.time])) {
//           _transExright(days, rights[j], mode, start, i)
//           break
//         }
//       }
//     }
//   } else if (mode === 'backword') {}
//   return days
// }
